export default {
  routeDetails: {
    'routeDetails': 'Dettagli percorso',
    'warnings': 'Allerta',
    'routes': 'Itinerari',
    'route': 'Itinerario',
    'segments': 'Segmenti',
    'segment': 'Segmento',
    'instructions': 'Indicazioni',
    'instruction': 'Indicazione',
    'name': 'Nome',
    'selectRoute': 'Seleziona l\'itinerario',
    'selectedRoute': 'Itinerario selezionato',
    'gotoSegment': 'Vai al segmento',
    'warningCodes': {
      '1': 'Potrebbero esserci restrizioni su alcune strade',
      '2': 'Ci sono delle strade a pedaggio lungo il percorso',
      '3': 'Questo itinerario si basa su vie dirette. Durata e restrizioni sulle strade potrebbero non essere corrette.',
      '4': 'Almeno un\'opzione extra richiesta non è disponibile.'
    },
    'routeOpacity': 'Opacità del percorso'
  }
}
